import styled from "@emotion/styled"
import { useState } from "react"
import { extractProperty } from "utils"
import DocumentHeader from "./components/DocumentHeader"
import DownloadProgressDialog from "./components/DownloadProgressDialog"
import FileTypeAccordion from "./components/FileTypeAccordion"
import SelectedFilesFloatingBar from "./components/SelectedFilesFloatingBar"
import { useFileSelection } from "./hooks/useFileSelection"

type Props = {
  title: string
  groupedFiles: any
  filteredFiles: any
  messages: any
}

const StyledContainer = styled.div`
  .MuiAccordionSummary-root {
    padding: 0px;
  }
  .MuiPaper-root {
    box-shadow: none;
    border-bottom: 1px solid #b5bfc9;
    ::before {
      display: none;
    }
  }
  .MuiAccordionSummary-content {
    margin: 0px;
    padding-bottom: 20px;
    padding-top: 20px;
    ${(props) => props.theme.breakpoints.down("md")} {
      padding-bottom: 16px;
    }
  }
`

const DocumentDisplay = ({ title, groupedFiles, filteredFiles, messages }: Props) => {
  const {
    selectedCount,
    createUniqueFileId,
    handleFileSelection,
    isFileSelected,
    getSelectedFiles,
    getAllDownload,
    selectedFiles,
    downloadProgress,
  } = useFileSelection()

  const [open, setOpen] = useState(false)

  const handleDownloadAll = () => {
    getAllDownload(filteredFiles)
    setOpen(true)
  }

  const handleDownloadSelected = () => {
    const filesToDownload = getSelectedFiles()
    if (filesToDownload.length > 0) {
      getAllDownload(filesToDownload)
    }
  }

  const handleDownloadByType = (files: any[]) => {
    getAllDownload(files)
  }

  // Get file name if there's only one file
  const getFileName = () => {
    if (filteredFiles.length === 1) {
      return extractProperty(filteredFiles[0]?.file, "fileName")
    }
    return undefined
  }

  return (
    <StyledContainer>
      <DocumentHeader
        title={title}
        totalFiles={Object.values(groupedFiles).flat().length}
        messages={messages}
        onDownloadAll={handleDownloadAll}
      />

      {/* File type accordions */}
      {Object.entries(groupedFiles).map(([fileType, files]) => (
        <FileTypeAccordion
          key={fileType}
          fileType={fileType}
          files={files as any[]}
          messages={messages}
          onDownloadType={handleDownloadByType}
          onFileSelection={handleFileSelection}
          isFileSelected={isFileSelected}
          createUniqueFileId={createUniqueFileId}
          downloadProgress={downloadProgress}
          totalFiles={filteredFiles.length}
        />
      ))}

      {/* Floating bar for selected files */}
      <SelectedFilesFloatingBar
        selectedCount={selectedCount}
        messages={messages}
        onDownloadSelected={handleDownloadSelected}
        downloadProgress={downloadProgress}
        totalFiles={filteredFiles.length}
        filteredFiles={selectedFiles}
      />

      <DownloadProgressDialog
        open={open}
        onClose={() => setOpen(false)}
        downloadProgress={downloadProgress}
        selectedCount={Object.values(groupedFiles).flat().length}
        totalFiles={Object.values(groupedFiles).flat().length}
        messages={messages}
        fileName={getFileName()}
      />
    </StyledContainer>
  )
}

export default DocumentDisplay
